module.exports = __webpack_public_path__ + "static/media/blueTick.3c99a91e.svg";